<template>
  <div>
    <es-exception
      v-if="!hasModule('PRSID:DWNLD:DOWNLOAD')"
      exceptionMessage="Sorry, you are not authorized to access this content."
    />
    <div class="document-container">
      <div class="columns">
        <div class="column">
          <div class="document">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    Download Options
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <es-loader v-if="loading"/>
              <div v-else>
                <es-form>
                  <template #es-form-header>
                    <div class="header-container">
                      <div class="header-elements">
                        <font-awesome-icon
                          :icon="['fas', 'poll']"
                          size="lg"
                        />
                      </div>
                      <div class="header-elements">
                        <h6 class="title">
                          Match Status
                        </h6>
                      </div>
                    </div>
                  </template>
                  <template #es-form>
                    <table
                      v-if="batchObject
                        && isDownloadTypesAllowed
                        && (recordGroupCategories.length)"
                      class="table is-fullwidth"
                    >
                      <thead>
                        <th class="text-align--left has-text-grey"></th>
                        <th
                          class="text-align--left has-text-grey"
                          title="Status"
                        >
                          Status
                        </th>
                        <th
                          class="text-align--left has-text-grey"
                          title="Submission Date"
                        >
                          Submission Date
                        </th>
                        <th
                          class="text-align--right has-text-grey"
                          title="Downloadable Record Count"
                        >
                          Downloadable Record Count
                        </th>
                        <th
                          class="text-align--right has-text-grey"
                          title="Total Record Count"
                        >
                          Total Record Count
                        </th>
                      </thead>
                      <tbody
                        v-for="(category,index) in recordGroupCategories"
                        :key="index"
                      >
                        <td class ="text-align--left">
                          <input
                            type="radio"
                            v-model="transGroupCode"
                            :value="category.code"
                            :aria-label="category.code"
                          >
                        </td>
                        <td class ="text-align--left">
                          {{ category.group }}
                        </td>
                        <td class ="text-align--left">
                          {{ formatDateTime(batchObject.createdDate) }}
                        </td>
                        <td class ="text-align--right">
                          <span v-if="isRejected">
                            N/A
                          </span>
                          <span v-else>
                            {{ category.totalCount }}
                          </span>
                        </td>
                        <td class ="text-align--right">
                          <span v-if="isRejected">
                            N/A
                          </span>
                          <span v-else>
                            {{ batch.recordCount  }}
                          </span>
                        </td>
                      </tbody>
                    </table>
                    <es-exception
                      v-else
                      style="margin:2rem"
                      exceptionMessage="No records are available for download."
                    />
                  </template>
                </es-form>
                <es-form
                  v-if="isDownloadTypesAllowed
                    && (recordGroupCategories.length)
                    && !isRejected"
                >
                  <template #es-form-header>
                    <div class="header-container">
                      <div class="header-elements">
                        <font-awesome-icon
                          :icon="['fas', 'file-edit']"
                          size="lg"
                        />
                      </div>
                      <div class="header-elements">
                        <h6 class="title">
                          Format
                        </h6>
                      </div>
                    </div>
                  </template>
                  <template #es-form>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">
                            Download Type
                          </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button
                                  v-for="(option, index) in downloadFormOptions"
                                  class="button no-radius"
                                  :key="index"
                                  :class="{'selected-option': downloadOption === option}"
                                  @click="selectType('downloadOption', option)"
                                >
                                  {{ option }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template v-if="downloadOption === 'Advanced'">
                      <div class="row removeUnderline">
                        <div class="field is-horizontal ">
                          <div class="field-label is-normal">
                            <label class="label">
                              File Format
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="buttons has-addons">
                                  <div class="text-align">
                                    {{ personIdFileFormat }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row removeUnderline">
                        <div class="field is-horizontal">
                          <div class="field-label is-normal">
                            <label class="label">
                              Delimiter
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="buttons has-addons">
                                  <button
                                    v-for="(item, index) in delimiterOptions"
                                    class="button no-radius"
                                    :key="index"
                                    :class="{'selected-option': delimiter === item.option}"
                                    @click="selectType('delimiter', item.option)"
                                  >
                                    {{ item.label }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row removeUnderline">
                        <div class="field is-horizontal">
                          <div class="field-label is-normal">
                            <label class="label">
                              Qualifier
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="buttons has-addons">
                                  <button
                                    v-for="(item, index) in qualifierOptions"
                                    class="button no-radius"
                                    :key="index"
                                    :class="{'selected-option': qualifier === item.option}"
                                    @click="selectType('qualifier', item.option)"
                                  >
                                    {{ item.label }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row removeUnderline">
                        <div class="field is-horizontal">
                          <div class="field-label is-normal">
                            <label class="label">
                              Date Format
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="select is-half-width">
                                  <select
                                    class="input is-full-width"
                                    v-model="dateFormat"
                                    aria-label="Date Format"
                                  >
                                    <option
                                      v-for="(item, index) in dateFormatOptions"
                                      :key="index"
                                      :value="item.option"
                                    >
                                      {{ item.label }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row removeUnderline">
                        <div class="field is-horizontal">
                          <div class="field-label is-normal">
                            <label class="label">
                              Include Header/Footer
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field">
                              <div class="control">
                                <div class="buttons has-addons">
                                  <button
                                    v-for="(item, index) in includeHeaderFooterOptions"
                                    class="button no-radius"
                                    :key="index"
                                    :disabled="nearMatchDetails"
                                    :class="{
                                      'selected-option': includeHeaderFooter === item.option
                                    }"
                                    @click="selectType('includeHeaderFooter', item.option)"
                                  >
                                    {{ item.label }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </es-form>
              </div>
              <div
                v-if="(recordGroupCategories.length) && isDownloadTypesAllowed"
                class="es-actions"
              >
                <es-form-actions>
                  <template #form-actions>
                    <div class="bottom-content">
                      <ul>
                        <li>
                          <div
                            class="list-content"
                            style="padding-right:5rem"
                          >
                            <button
                              class="button is-primary"
                              @click="checkSelectedStatus()"
                            >
                              Generate Extract
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </es-form-actions>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!isRejected"
          class="column is-one-quarter"
        >
          <div class="document">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    Download History
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <es-loader v-if="loadingHistory"/>
              <div v-else>
                <table class="table is-fullwidth">
                  <thead>
                    <th class="has-text-grey text-align--left">
                      User ID
                    </th>
                    <th class="has-text-grey text-align--left">
                      Download Date
                    </th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(category,index) in history"
                      class= "form-row"
                      :key="index"
                    >
                      <td class="text-align--left">
                        {{ category.userEmail }}
                      </td>
                      <td class="text-align--left">
                        {{ formatDateTime(category.lastUpdateDate) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div
        v-if="showExtract"
        class="document-container"
        style="padding-top: 0"
      >
        <div class="document">
          <div class="header">
            <es-header>
              <template #header>
                <div class="header-title">
                  Extract File (1)
                </div>
              </template>
            </es-header>
          </div>
          <div class="content table-container">
            <es-loader v-if="loadingExtract"/>
            <table
              v-else
              class="table is-hoverable is-fullwidth"
            >
              <thead>
                <tr>
                  <th title="Extract Date">
                    Extract Date
                  </th>
                  <th title="Location Info" v-if="!isRejected">
                    Location Info
                  </th>
                  <th title="Record Count">
                    Record Count
                  </th>
                  <th title="Extract Name">
                    Extract Name
                  </th>
                  <th title="Extract Status">
                    Extract Status
                  </th>
                  <th title="Actions">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isRejected">
                  <td>
                    <div class="has-text-weight-bold">
                      {{ formatExtractDate(extract.createdDate) }}
                    </div>
                    <div>
                      <span class="padding-left--small has-text-grey">
                        {{ formatExtractTime(extract.createdDate) }}
                      </span>
                    </div>
                  </td>
                  <!-- <td >
                    --
                  </td> -->
                  <td>
                    <div class="has-text-weight-bold">
                      N/A
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ this.fileNameForRejected }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      Complete
                    </div>
                  </td>
                  <td class="action">
                    <div>
                      <a :href="downloadRejected()">
                        Download
                      </a>
                    </div>
                  </td>
                </tr>
                <tr v-else>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ formatExtractDate(extract.createdDate) }}
                    </div>
                    <div>
                      <span class="padding-left--small has-text-grey">
                        {{ formatExtractTime(extract.createdDate) }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="is-flex flex-direction--column">
                      <div v-if="isMultiDistrict">
                        <b style="font-size:14px">
                          Multiple Locations
                        </b>
                      </div>
                      <div v-else>
                        <router-link
                          :to="{
                            name: 'PIDistrictInfoDetails',
                            params: {
                              code: batch.pidBatchDistrictSchoolAssociation[0].districtCode,
                            },
                          }"
                          class="has-text-weight-bold has-text-primary" style="font-size:14px"
                        >
                          {{ batch.pidBatchDistrictSchoolAssociation[0].district.location.name }}
                        </router-link>
                        <span class="padding-left--small has-text-grey is-italic">
                          ({{ batch.pidBatchDistrictSchoolAssociation[0].districtCode }})
                        </span>
                      </div>
                      <div v-if="isMultiSchool">
                        <span class="is-italic has-text-grey">
                          Multiple Buildings
                        </span>
                      </div>
                      <div v-else>
                        <router-link
                          :to="{
                            name: 'PISchoolInfoDetails',
                            params: {
                              districtCode: batch.pidBatchDistrictSchoolAssociation[0].districtCode,
                              schoolCode: batch.pidBatchDistrictSchoolAssociation[0].schoolCode,
                            },
                          }"
                          class="is-italic"
                        >
                          {{ batch.pidBatchDistrictSchoolAssociation[0].school.location.name }}
                        </router-link>
                        <span class="padding-left--small has-text-grey is-italic">
                          ({{ batch.pidBatchDistrictSchoolAssociation[0].schoolCode }})
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ extract.totalCount ? extract.totalCount : "In progress"}}
                      of {{ batch.recordCount }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ extract.fileName }}
                    </div>
                  </td>
                  <td>
                    <div class="has-text-weight-bold">
                      {{ statusName }}
                    </div>
                  </td>
                  <td class="action">
                    <div v-if="(statusId === 3)">
                      <a v-if="extract.fileExtension"
                        :href="buildSplitUrl(extractId)"
                      >
                        Download
                      </a>
                    </div>
                    <div v-else>
                      <a @click="refreshExtract"
                        @keypress="refreshExtract"
                        role="link"
                        tabindex="0"
                      >
                        Refresh
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <iframe
        ref="downloadFrame"
        title="Download - Extract File">
      </iframe>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faClock,
  faFileEdit,
  faPoll,
  faSort,
  faSyncAlt,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faClock,
  faFileEdit,
  faPoll,
  faSort,
  faSyncAlt,
);
export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsForm,
    EsFormActions,
    EsHeader,
    EsLoader,
  },
  props: [
    'batch',
  ],
  data() {
    return this.initialData();
  },
  created() {
    this.onLoad();
  },
  watch: {
    nearMatchDetails(newValue) {
      this.includeHeaderFooter = !newValue;
    },
    // transGroupCode() {
    //   if (!this.isRejected) {
    //     this.nearMatchDetails();
    //   }
    // },
  },
  computed: {
    ...mapGetters('lookups', [
      'pidTransactionExtractStatuses',
      'pidExtractStatuses',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    allowedExtractDownloadTypes() {
      return this.$store.state.propertiesModule.properties['PERSON-EXTRACT_DOWNLOAD_TYPES_ALLOWED'];
    },
    formDataBody() {
      const formData = new FormData();
      formData.append('pidBatchId', this.batch.id);
      formData.append('transGroupCode', this.transGroupCode);
      formData.append('referrer', this.referrer);
      if (this.downloadOption === 'Advanced') {
        formData.append('delimiter', this.delimiter);
        if (this.qualifier !== null) {
          formData.append('qualifier', this.qualifier);
        }
        formData.append('dateFormat', this.dateFormat);
      }
      formData.append('includeHeaderFooter', this.includeHeaderFooter);

      return formData;
    },
    isDownloadTypesAllowed() {
      if (this.allowedExtractDownloadTypes) {
        return this.allowedExtractDownloadTypes.includes(this.batchObject.submissionTypeCode);
      } return null;
    },
    isMultiDistrict() {
      const setOfUniqueDistricts = this.batch.pidBatchDistrictSchoolAssociation
        .map(a => a.districtCode)
        .slice().sort((a, b) => a > b)
        .reduce((a, b) => { if (a.slice(-1)[0] !== b) a.push(b); return a; }, []);
      if (setOfUniqueDistricts.length > 1) return true;
      return false;
    },
    isMultiSchool() {
      const setOfUniqueSchools = this.batch.pidBatchDistrictSchoolAssociation.map(a => a.schoolCode)
        .slice().sort((a, b) => a > b)
        .reduce((a, b) => { if (a.slice(-1)[0] !== b) a.push(b); return a; }, []);
      if (setOfUniqueSchools.length > 1) return true;
      return false;
    },
    isRejected() {
      return this.batchObject.status === 'REJECTED';
    },
    latestId() {
      if (this.history.length !== 0) {
        return this.history.reduce((a, b) => (Number(a.id) > Number(b.id) ? a : b));
      }
      return null;
    },
    nearMatchDetails() {
      return this.transGroupCode === 'IDNMD';
    },
    recordGroupCategories() {
      const tansactionGroups = this.allTransactionStatusGroup();
      const tranStatusGroups = JSON.parse(JSON.stringify(tansactionGroups));
      tranStatusGroups.forEach((code, outerIndex) => {
        const total = [];
        tranStatusGroups[outerIndex].list.forEach((s) => {
          if (s.count) {
            total.push(s.count);
          }
          tranStatusGroups[outerIndex].totalCount = total.reduce((a, b) => a + b, 0);
        });
      });
      if (tranStatusGroups.length) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.transGroupCode = tranStatusGroups[0].code;
      }
      return tranStatusGroups;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionExtractStatuses',
      'loadPidExtractStatuses',
    ]),
    allTransactionStatusGroup() {
      this.transactionStatuses = this.pidTransactionExtractStatuses;
      const tranStatusGroups = JSON.parse(JSON.stringify(this.transactionStatuses));
      if (this.isRejected) {
        return tranStatusGroups.filter(a => a.group === 'Rejected');
      }
      try {
        this.batchObject.pidBatchTransStatusCountAssociation.forEach((tranStatus) => {
          tranStatusGroups.forEach((group, outerIndex) => {
            if (group.list.map(n => n.id).flat().includes(tranStatus.status)) {
              tranStatusGroups[outerIndex].list.forEach((s, innerIndex) => {
                if (s.id === tranStatus.status) {
                  tranStatusGroups[outerIndex].list[innerIndex].count = tranStatus.statusCount;
                  tranStatusGroups[outerIndex].showThisGroup = true;
                }
              });
            }
          });
        });
      } catch (error) {
        throw error;
      }
      return tranStatusGroups.filter(x => x.showThisGroup);
    },
    buildSplitUrl(dlFileId) {
      return `${axios.defaults.baseURL}personid/extracts/${dlFileId}/content`;
    },
    checkSelectedStatus() {
      if (this.transGroupCode === null) {
        this.showNotification('danger', [this.statusError]);
      } else {
        this.resetNotifications();
        this.generateExtract();
      }
    },
    downloadFile(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    downloadRejected() {
      return `${axios.defaults.baseURL}personid/rejected/${this.batch.id}/content`;
    },
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mmA');
    },
    formatExtractDate(value) {
      return moment(value).format('MM/DD/YYYY');
    },
    formatExtractTime(value) {
      return moment(value).format('h:mmA');
    },
    async generateExtract() {
      try {
        this.loadingExtract = true;
        this.resetNotifications();
        if (this.isRejected) {
          this.generateRejectedFileName();
        } else {
          const response = await axios.post('personid/extracts', this.formDataBody);
          this.extract = response.data;
          this.findId = this.extract.extractStatusId;
          this.extractId = this.extract.id;
          this.getExtractStatus();
        }
        this.showExtract = true;
      } catch (error) {
        this.showNotification('danger', ['Error generating extract']);
      } finally {
        this.loadingExtract = false;
      }
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    },
    generateRejectedFileName() {
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM'; // Determine AM/PM
        return `${month}${day}${year}_${hours}${minutes}${ampm}`;
      };
      this.fileNameForRejected = `PID_BATCHPROFILE_${this.batch.id}_${formatDate(new Date())}_IDREJ.txt`;
    },
    async getExtract() {
      try {
        this.loadingExtract = true;
        const response = await axios.get(`personid/extracts/${this.extractId}`);
        this.extract = response.data;
        this.findId = this.extract.extractStatusId;
        this.extractId = this.extract.id;
        this.getExtractStatus();
        this.showExtract = true;
      } catch (error) {
        this.showNotification('danger', ['Error getting extract record']);
      } finally {
        this.loadingExtract = false;
      }
    },
    getExtractStatus() {
      this.extractStatuses = this.pidExtractStatuses;
      this.extractStatuses.forEach((id, outerIndex) => {
        if (this.extractStatuses[outerIndex].id === this.findId) {
          this.statusName = this.extractStatuses[outerIndex].name;
          this.statusId = this.extractStatuses[outerIndex].id;
        }
      });
    },
    initialData() {
      return {
        batchObject: this.batch,
        dateFormat: 'MM/dd/yyyy',
        dateFormatOptions: [
          { label: 'mm/dd/yyyy', option: 'MM/dd/yyyy' },
          { label: 'ISO Format (YYYY-MM-DD)', option: 'YYYY-MM-dd' },
          { label: 'mm/d/yyyy', option: 'MM/d/yyyy' },
          { label: 'm/d/yyyy', option: 'M/d/yyyy' },
          { label: 'm/dd/yyyy', option: 'M/dd/yyyy' },
        ],
        delimiter: '09',
        delimiterOptions: [
          { label: 'Tab', option: '09' },
          { label: 'Comma', option: ',' },
        ],
        downloadFormOptions: ['Simple', 'Advanced'],
        downloadOption: 'Simple',
        extract: [],
        extractStatuses: [],
        extractId: null,
        fileNameForRejected: null,
        findId: null,
        includeHeaderFooter: true,
        includeHeaderFooterOptions: [
          { label: 'Yes', option: true },
          { label: 'No', option: false },
        ],
        lastDate: null,
        loading: false,
        loadingError: false,
        loadingExtract: false,
        loadingHistory: false,
        history: [],
        personIdFileFormat: 'Version 3.0',
        qualifier: null,
        qualifierOptions: [
          { label: 'Double Quotes ( " )', option: '"' },
          // We may need Single Quote back in the future.
          // { label: "Single Quote ( ' )", option: "'" },
          { label: 'None', option: null },
        ],
        referrer: 'BATCHPROFILE',
        selectedForRejected: 'Rejected',
        showExtract: false,
        statusId: null,
        statusName: null,
        statusObject: [],
        statusError: 'No Status Selected',
        transactionStatuses: [],
        transactionStatusGroup: [],
        transGroupCode: null,
      };
    },
    async loadHistory() {
      this.loadingHistory = true;
      try {
        const response = await axios.get('personid/extracts', {
          params: {
            pidBatchId: this.batch.id,
          },
        });
        this.history = response.data.slice(0, 13);
      } catch (error) {
        this.showNotification('danger', ['Error loading history']);
      } finally {
        this.loadingHistory = false;
      }
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadPidExtractStatuses(),
          this.loadPidTransactionExtractStatuses(),
        ]);

        this.allTransactionStatusGroup();
        if (!this.isRejected) {
          this.loadHistory();
        }
        if (this.history !== null && this.history.length !== 0) {
          this.extractId = this.latestId.id;
          this.getExtract();
        }
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    refreshExtract() {
      this.getExtract();
      this.loadHistory();
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    selectType(field, option) {
      if (field === 'downloadOption') {
        this.downloadOption = option;
      }
      if (field === 'dmatchFileFormat') {
        this.dmatchFileFormat = option;
      }
      if (field === 'delimiter') {
        this.delimiter = option;
      }
      if (field === 'qualifier') {
        this.qualifier = option;
      }
      if (field === 'includeHeaderFooter') {
        this.includeHeaderFooter = option;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .column-header
    padding-left: 0px
  .fields-container
    margin-left: 30px
  .header-container
    margin-bottom: 1rem
  .margin-bottom
    margin-bottom: 1rem
  .no-radius
    border-radius: 0
    background-color: #F2F2F2
    font-weight: normal
  .selected-option
    background-color: #ccc
    font-weight: bold
  .sort-by
    padding-right: 18px
    position: relative
    color: #777
    text-decoration: none
    &:before, &:after
    border: 4px solid transparent
    content: ""
    display: block
    height: 0
    right: 5px
    top: 50%
    position: absolute
    width: 0
    &:before
      border-bottom-color: #999
      margin-top: -9px
      &:after
        border-top-color: #999
        margin-top: 1px
  .text-align--left
    text-align: left !important
  .text-align--right
    text-align: right !important
  .table-container
    overflow-x: autho
    white-space: no-wrap
  @media screen and (max-width: 70em)
    .columns
      display: block
      .column
        width: 100%
</style>
